import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_2 = { class: "e-badge e-badge-danger e-badge-pill" }
const _hoisted_3 = { colspan: "2" }
const _hoisted_4 = { colspan: "2" }
const _hoisted_5 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_6 = { class: "e-badge e-badge-danger e-badge-pill" }

import OrderHead, {OrderStatus, OrderType} from "@/shared/model/orderHead";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import Payment from "@/shared/model/Payment";

interface Props {
  orderHead?: OrderHead,
  payment?: Payment
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderHeadComponent',
  props: {
    orderHead: { default: undefined },
    payment: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _accountStore = useAccountStore();

const {isBranch} = storeToRefs(_accountStore)


const _isPriceVisible = computed(() => {
  return !(isBranch.value)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _cache[0] || (_cache[0] = _createElementVNode("td", null, "Datum", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.orderedDate,
          "value-type": "DateTime"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[1] || (_cache[1] = _createElementVNode("td", null, "Kunde", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.personName
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[2] || (_cache[2] = _createElementVNode("td", null, "Lieferant", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.supplierName
        }, null, 8, ["value"])
      ])
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[3] || (_cache[3] = _createElementVNode("td", null, "Lieferung an", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.deliveryPersonName
        }, null, 8, ["value"])
      ])
    ], 512), [
      [_vShow, __props.orderHead.deliveryPersonId]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[4] || (_cache[4] = _createElementVNode("td", null, "Zahlungsbetrag", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.orderAmount,
          "value-type": _unref(SogDataLabelValueType).Money
        }, null, 8, ["value", "value-type"])
      ])
    ], 512), [
      [_vShow, _isPriceVisible.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[5] || (_cache[5] = _createElementVNode("td", null, "VersSt", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.insuranceTaxAmount,
          "value-type": "Money"
        }, null, 8, ["value"])
      ])
    ], 512), [
      [_vShow, _isPriceVisible.value]
    ]),
    _createElementVNode("tr", null, [
      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Bestellt durch", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.orderedByPersonName
        }, null, 8, ["value"])
      ])
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Bezahlt", -1)),
      _createElementVNode("td", null, [
        _withDirectives(_createElementVNode("span", _hoisted_1, "ja", 512), [
          [_vShow, __props.orderHead.paid]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_2, "nein", 512), [
          [_vShow, !__props.orderHead.paid]
        ])
      ])
    ], 512), [
      [_vShow, __props.orderHead.orderType===_unref(OrderType).Invoice]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[8] || (_cache[8] = _createElementVNode("td", null, "am", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          "value-type": _unref(SogDataLabelValueType).Date,
          value: __props.payment.date
        }, null, 8, ["value-type", "value"])
      ])
    ], 512), [
      [_vShow, __props.payment]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_3, [
        _createVNode(SogDataLabel, {
          "value-type": _unref(SogDataLabelValueType).String,
          value: __props.payment.bank
        }, null, 8, ["value-type", "value"])
      ])
    ], 512), [
      [_vShow, __props.payment&&__props.payment.bank]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_4, [
        _createVNode(SogDataLabel, {
          "value-type": _unref(SogDataLabelValueType).String,
          value: __props.payment.memo
        }, null, 8, ["value-type", "value"])
      ])
    ], 512), [
      [_vShow, __props.payment&&__props.payment.memo]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Abgerechnet", -1)),
      _createElementVNode("td", null, [
        _withDirectives(_createElementVNode("span", _hoisted_5, "ja", 512), [
          [_vShow, __props.orderHead.invoiced]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_6, "nein", 512), [
          [_vShow, !__props.orderHead.invoiced]
        ])
      ])
    ], 512), [
      [_vShow, __props.orderHead.orderType===_unref(OrderType).Order]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Status", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogIcon, { icon: "mdi-truck-fast" })
      ])
    ], 512), [
      [_vShow, __props.orderHead.statusId!==_unref(OrderStatus).Completed]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Referenznummer", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: __props.orderHead.invoiceCircle
        }, null, 8, ["value"])
      ])
    ], 512), [
      [_vShow, __props.orderHead.invoiceCircle]
    ])
  ]))
}
}

})